import { Children, useRef, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { CaretDown, Check, MagnifyingGlass } from '@phosphor-icons/react';

const RegistrationSelect = ({ children, name, value, onChange, required, disabled }) => {
    const [open, setOpen] = useState(false);
    const [query, setQuery] = useState('');
    const [invalid, setInvalid] = useState(false);
    const toggleRef = useRef(null);
    const options = Children.toArray(children).filter((child) => child?.type === 'option');
    const selected = options.find((option) => String(option.props.value) === String(value));
    const placeholder = options.find((option) => !option.props.value)?.props.children || 'Select an option';
    const filtered = options.filter((option) => String(option.props.children).toLowerCase().includes(query.trim().toLowerCase()));

    return (
        <Dropdown className="registration-select" show={open} onToggle={(next) => { setOpen(next); if (!next) setQuery(''); }}>
            {/* Retain native required-field validation and form values. */}
            <select name={name} value={value} required={required} disabled={disabled} tabIndex={-1} aria-hidden="true" className="registration-select-native" onChange={onChange}
                onInvalid={(event) => { event.preventDefault(); setInvalid(true); toggleRef.current?.focus(); }}>
                {children}
            </select>
            <Dropdown.Toggle ref={toggleRef} variant="" disabled={disabled} className="registration-select-toggle" aria-label={`${placeholder}: ${selected?.props.children || ''}`} aria-invalid={invalid}>
                <span className={!value ? 'registration-select-placeholder' : undefined}>{selected?.props.children || placeholder}</span><CaretDown size={17} aria-hidden="true" />
            </Dropdown.Toggle>
            <Dropdown.Menu className="registration-select-menu">
                {options.length > 6 && <div className="registration-select-search"><MagnifyingGlass size={17} aria-hidden="true" /><input autoFocus value={query} onChange={(event) => setQuery(event.target.value)} placeholder="Search options…" aria-label={`Search ${placeholder}`} onKeyDown={(event) => { if (event.key !== 'Escape') event.stopPropagation(); }} /></div>}
                <div className="registration-select-options">
                    {filtered.map((option) => <Dropdown.Item as="button" type="button" key={option.props.value} active={String(option.props.value) === String(value)} onClick={() => {
                        onChange({ target: { name, value: option.props.value } });
                        setInvalid(false); setOpen(false); setQuery(''); toggleRef.current?.focus();
                    }}><span>{option.props.children}</span>{String(option.props.value) === String(value) && <Check size={17} aria-hidden="true" />}</Dropdown.Item>)}
                    {!filtered.length && <div className="registration-select-empty">No matching options</div>}
                </div>
            </Dropdown.Menu>
            {invalid && <small className="registration-select-error" role="alert">Please choose an option.</small>}
        </Dropdown>
    );
};

export default RegistrationSelect;
